import React from 'react';
import './MyCloset.css';

// This file has been refactored. Please use the new MyCloset component from:
// susu_closet/src/components/my-closet/MyCloset.js

import MyClosetRefactored from '../my-closet/MyCloset';

function MyCloset({ guest, scrollToClothingId, selectVtoId }) {
  // Redirect to the new refactored component
  return <MyClosetRefactored guest={guest} scrollToClothingId={scrollToClothingId} selectVtoId={selectVtoId} />;
}

export default MyCloset;